// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"396":"eecd539b","782":"6030466b"}[chunkId] + ".chunk.js");